<template>

<v-main>
  <!-- <v-row>
    <v-col> -->
       
   <v-app-bar
   elevation="12"
     color="#202020"
     >

         <v-app-bar-title>
           <router-link to="/" >
               <v-img :src='require("@/assets/Brand/Maryud-Logo-Yellow.webp")' contain   height="4em" width="4em"></v-img>
            </router-link>
         </v-app-bar-title>
         <v-spacer></v-spacer>
         <v-tabs centered>
         <v-tab centered  class="hidden-md-and-down white--text montserrat"  to="/">{{ $t('home') }} </v-tab>
        
         <v-tab  centered class="hidden-md-and-down white--text montserrat"  to="/shows">{{ $t('shows') }} </v-tab>
           
         <v-tab  centered class="hidden-md-and-down white--text montserrat"  to="/aboutus"> {{ $t('about') }} </v-tab>
    
         <v-tab centered class="hidden-md-and-down white--text montserrat"  to="/gallery">{{ $t('gallery') }}</v-tab>
         
         <v-tab centered class="hidden-md-and-down montserrat white--text"  to="/contact">{{ $t('contact') }}</v-tab>
         </v-tabs>
           
        
         <v-spacer></v-spacer>
         <v-btn  outlined color="primary" @click="toggleLang" class="locale-changer">
               {{$t('lang')}}
         </v-btn>
         
         
         

   </v-app-bar>
 </v-main>
</template>


<script>
// import LottieAnimation from 'lottie-web-vue'
import store from '../store/index'
// import MenuBtn from './MenuBtn.vue'
 

export default {
    name:'Header',
  //  components: {
  //   MenuBtn
  //  },
   data:()=>{
     return {
        Lang:'en',
        }
   },
   methods:{
     toggleLang(){
        if (this.Lang == 'en') {
          this.Lang ='ar';
         } else  {        
          this.Lang = 'en';
        }
       this.$i18n.locale = this.Lang
       store.dispatch('toggleFont')
     },
      playSound(){
         store.dispatch('playSound')
       }
  }
  //  mounted(){
  //     var audio = new Audio(require('../assets/playlist.pls'))
  //      audio.play()
  //  }
    
    
}
</script>
<style>
@import '../scss/header.scss'
</style>